var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tree-title",
      style: {
        "margin-bottom": _vm.marginBottom,
        "line-height": _vm.lineHeight
      },
      attrs: { title: _vm.treeTitle }
    },
    [_vm._v("\n  " + _vm._s(_vm.treeTitle) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-797b9fb5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-797b9fb5","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EXHoverTitle/index.vue
// module id = 424
// module chunks = 0